import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-gov-west-1_xH3EHsOkp",
  ClientId: "1heovbd274phpd22bblkn0l1jm",
};

export default new CognitoUserPool(poolData);